<script setup lang="ts">
  import { useAuth } from '@/composition/use-auth';
  import { useOrders } from '@/composition/use-orders';
  import { useReservationsRealtime } from '@/composition/reservations/use-reservations-realtime';
  import { useWhatsNew } from '@/composition/use-whats-new';
  import { useOfflineStore } from '@/stores/offline.store';

  const authHelper = useAuth(true);
  const ordersHelper = useOrders(true);
  useReservationsRealtime();
  const offlineStore = useOfflineStore();
  useWhatsNew();
</script>

<template>
  <div class="setup-context"></div>
</template>

<style scoped lang="scss"></style>
